import styled from '@emotion/styled'

export type ChipVariant = 'default' | 'accent' | 'warn' | 'danger'
export type ChipTone = 'text' | 'mono'

export interface ChipStyleProps {
  variant?: ChipVariant
  tone?: ChipTone
}

const VARIANT_BG: Record<ChipVariant, string> = {
  default: 'var(--c-bg-sunk)',
  accent: 'var(--c-accent-soft)',
  warn: 'color-mix(in oklab, var(--c-warn) 18%, var(--c-bg-elev))',
  danger: 'color-mix(in oklab, var(--c-danger) 14%, var(--c-bg-elev))',
}

const VARIANT_FG: Record<ChipVariant, string> = {
  default: 'var(--c-fg-muted)',
  accent: 'var(--c-accent)',
  warn: 'var(--c-fg)',
  danger: 'var(--c-danger)',
}

// `tone="mono"` flips a Chip into the small monospace tag used in slide
// chrome / area shells (uppercase, tracked, mono). The shape and variants
// stay the same so consumers can pick a tone without re-implementing.
export const Chip = styled.span<ChipStyleProps>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: var(--r-full);
  font-weight: 500;

  font-family: ${({ tone = 'text' }) => (tone === 'mono' ? 'var(--font-mono)' : 'var(--font-sans)')};
  font-size: ${({ tone = 'text' }) => (tone === 'mono' ? 'var(--t-eyebrow)' : 'var(--t-body-sm)')};
  letter-spacing: ${({ tone = 'text' }) => (tone === 'mono' ? '0.08em' : '0.01em')};
  text-transform: ${({ tone = 'text' }) => (tone === 'mono' ? 'uppercase' : 'none')};

  background: ${({ variant = 'default' }) => VARIANT_BG[variant]};
  color: ${({ variant = 'default' }) => VARIANT_FG[variant]};
  border: 1px solid
    ${({ variant = 'default' }) => (variant === 'accent' ? 'transparent' : 'var(--c-border)')};
`
